import React, { useContext, useMemo } from 'react';
import { CSSObject } from 'styled-components';
import DropDown from 'src/components/DropDown/DropDown';
import { PlacemenContext } from '../../context';
import hooks from './hooks.PlacementAddressSelection';
import styles from './styles.PlacementAddressSelection';
import { EditedOrderAddresses } from './orderAddress.PlacementAddressSelection';

interface Props {
    selectedPassengerCode: string;
    selectedTab: 'auto' | 'manual';
    /** When editing an order: the addresses saved on it (D-058); null keeps the passenger's default */
    orderAddresses?: EditedOrderAddresses;
    /** Inside the addresses step frame the container needs no top padding of its own */
    containerStyle?: CSSObject;
}

const PlacementAddressSelection = ({ selectedPassengerCode, selectedTab, orderAddresses, containerStyle }: Props) => {
    const { createProps } = hooks.useDropdownProps(selectedPassengerCode, selectedTab, orderAddresses);

    return (
        <styles.AddressSelectionContainer style={containerStyle}>
            <DropDown {...createProps('pickup')} />
            <DropDown {...createProps('drop')} />
        </styles.AddressSelectionContainer>
    );
};

export default PlacementAddressSelection;
